module.exports = __webpack_public_path__ + "img/box-02.bf9cbba4.jpg";